import SailboatOffshore16 from '@carbon/icons-react/es/sailboat--offshore/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { TimeoffResponse } from 'api/timeoff/types';
import { GetTimeOffTooltipContent } from 'components/atoms/time-off-tooltip';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  svg {
    color: var(--purple-60);
  }
`;

export const UserMessageCommentAuthor: FC<{
  userFullName: string;
  timeOff: TimeoffResponse | undefined;
}> = ({ timeOff, userFullName }) => {
  const timeOffText = (
    <GetTimeOffTooltipContent timeOff={timeOff} userName={userFullName} />
  );

  return (
    <Wrapper>
      <strong>{userFullName}</strong>
      {!!timeOff && (
        <Tooltip title={timeOffText}>
          <SailboatOffshore16 />
        </Tooltip>
      )}
    </Wrapper>
  );
};
